import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ContentLoaderComponent, ContentLoaderModule} from "@ngneat/content-loader";
import {ColorEnum} from "../../../../_variables";

@Component({
  selector: 'app-dashboard-page-loader',
  template: `
      <content-loader class="border-box-full svg-sizing"
                      [style.height.px]="height"
                      [foregroundColor]="colorEnum.medium_grey"
                      [backgroundColor]="backgroundColor" [viewBox]="$any(null)" >
          <svg:rect x="0" y="0" width="110%" height="110%"/>
      </content-loader>
  `,
  imports: [
    ContentLoaderModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardPageLoaderComponent extends ContentLoaderComponent {
	@Input() height: number;
	@Input() backgroundColor = '#fff'
	colorEnum = ColorEnum;
}
